module.exports = __webpack_public_path__ + "img/logo.68da9123.svg";